import React from 'react';
import { Navigate } from 'react-router';
import { useUserRoles } from 'hooks/useUserRoles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface Props {
  children: React.ReactNode;
}

const BlogRoute = ({ children }: Props) => {
  // In cookie mode, check for user data instead of token
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = token || user;
  const { hasAdminAccess, rolesResolved } = useUserRoles();

  if (!isAuthenticated) {
    return <Navigate to="/welcome" replace />;
  }

  // Wait for /users/me to settle before deciding. Without this, an admin or
  // writer who refreshes or deep-links here is bounced to /home while the
  // roles query is still in flight (user undefined => hasAdminAccess false).
  if (!rolesResolved) {
    return null;
  }

  if (!hasAdminAccess) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default BlogRoute;
